import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type CarRentalUiState = {
    carStatusFilter: string[];
};

const initialState: CarRentalUiState = {
    carStatusFilter: [],
};

const carRentalUiSlice = createSlice({
    name: 'carRentalUi',
    initialState,
    reducers: {
        setCarStatusFilter(state, action: PayloadAction<string[]>) {
            state.carStatusFilter = action.payload;
        },
    },
});

export const { setCarStatusFilter } = carRentalUiSlice.actions;
export default carRentalUiSlice.reducer;
